export default {"src":"/_next/static/media/fullscreen-exit.62bd1028.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};